"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utcTimestamp = void 0;
const utcTimestamp = (d) => {
    const split = d.toISOString().split('T');
    return `${split[0]} ${split[1].split('.')[0]}`;
};
exports.utcTimestamp = utcTimestamp;
